import CommonNav from './CommonNav'
import React, { useRef, useEffect, useState } from 'react';
import { Button } from 'primereact/button';
import { Card } from 'primereact/card';
import { Endpoints } from "../constants/env/middletier";
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { useSearchParams } from "react-router-dom";
import { ProgressSpinner } from 'primereact/progressspinner';
import { useKeycloak } from "@react-keycloak/web";
import { Message } from 'primereact/message';
import { Dialog } from 'primereact/dialog';
import { useNavigate } from "react-router-dom";

export default function ViewSubRequest() {
    const [result, setResult] = useState([]);
    const [selectedSubs, setSelectedSubs] = useState([]);
    const [searchParams] = useSearchParams();
    const [loading, setLoading] = useState(true);
    const [jobAvailable, setJobAvailable] = useState(true);

    const substituteJobId = searchParams.get("substitute_job_id");
    const substituteId = searchParams.get("sub_id");

    const { keycloak, initialized } = useKeycloak();
    const userId = keycloak.tokenParsed.sub;
    const userFullName = keycloak.tokenParsed.name;
    console.log("User ID:", userId);
    console.log("User Name:", userFullName);
    const [showMessageSent, setShowMessageSent] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
    async function fetchSubJob() {
        try {
            const res = await fetch(Endpoints["getsubjob"] + `${substituteJobId}`);
            const data = await res.json();
            if(data.status.toUpperCase() != "PENDING") {
                setJobAvailable(false);
            }
            setResult([data]);
            console.log("Data Groups");
            console.log(data);
        } catch (err) {
            console.error("Failed to load groups", err);
        } finally {
            setLoading(false);
        }
    }
        fetchSubJob();
    }, []);

    const handleAcceptJob = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            const subJobAccept = {
                "substituteId": substituteId,
                "substituteKeycloakId": userId,
                "substituteKeycloakName": userFullName
            }

            const response = await fetch(Endpoints["acceptsubjob"] + `${substituteJobId}`, {
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(subJobAccept),
            });

            const result = await response.json();
            console.log("Success:", result);
        } catch (error) {
            console.error("Error accepting job:", error);
        } finally {
            setLoading(false);
            setShowMessageSent(true);
        }
    }

    const data_table_header = (
        <div className="flex flex-wrap align-items-center justify-content-between gap-2">
            {jobAvailable &&
            <Button label="Accept" icon="pi pi-check" severity="success" rounded iconPos="right"
            disabled={substituteId === "-1"} onClick={handleAcceptJob} />}

            {!jobAvailable &&
            <Message severity="warn" text="This job has already been accepted." />}
        </div>
    );

    const handleRequestComplete = () => {
        if (!showMessageSent)
            return;

        navigate("/viewMyJobs");
    };

    const showMessageSentfooterContent = (
        <div>
            <Button label="Ok" icon="pi pi-check" onClick={handleRequestComplete} autoFocus />
        </div>
    );

    return (
    <>
        <CommonNav></CommonNav>
        <br />
        <br />
        <div className="card flex flex-column align-items-center gap-3 ">
            {jobAvailable && <Card title="Job Details: " className="md:w-25rem">
                <div className="card flex flex-column align-items-center gap-5 ">
                    {result && result.length > 0 &&
                    <div className="formgrid grid">
                        <div className="field col-6">
                            <label htmlFor="teacher"><strong>Teacher: </strong></label>
                        </div>
                        <div className="field col-6">
                            <span id="teacher">{result[0].teacherFullName}</span>
                        </div>
                        <div className="field col-6">
                            <label htmlFor="startdate"><strong>Start Date:</strong> </label>
                        </div>
                        <div className="field col-6">
                            <span id="startdate">{result[0].startDate}</span>
                        </div>
                        <div className="field col-6">
                            <label htmlFor="enddate"><strong>End Date:</strong> </label>
                        </div>
                        <div className="field col-6">
                            <span id="enddate">{result[0].endDate}</span>
                        </div>
                        <div className="field col-6">
                            <label htmlFor="description"><strong>Description:</strong> </label>
                        </div>
                        <div className="field col-6">
                            <span id="description">{result[0].description}</span>
                        </div>
                        <div className="field col-6">
                            <label htmlFor="notes"><strong>Notes:</strong> </label>
                        </div>
                        <div className="field col-6">
                            <span id="notes">{result[0].notes}</span>
                        </div>
                        <div className="field col-6">
                            <label htmlFor="status"><strong>Status:</strong> </label>
                        </div>
                        <div className="field col-6">
                            <span id="status">{result[0].status}</span>
                        </div>
                    </div>}
                </div>
            </Card>}
        {data_table_header}

        <Dialog header="Success" footer={showMessageSentfooterContent} visible={showMessageSent}
                style={{ width: '25vw' }} onHide={handleRequestComplete}>
            <p className="m-0">
                Job has been accepted
            </p>
        </Dialog>


        </div>

    </ >
    );
}